import React from 'react'
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TableContainer,
  Typography,
  Box
} from '@mui/material'

export const PLANKTON_STATION_COLUMNS = [
  { label: 'Station ID', key: 'stationid' },
  { label: 'Source', key: 'source' },
  { label: 'Date', key: 'date' },
  { label: 'Year', key: 'yr' },
  { label: 'Vessel', key: 'vessel' },
  { label: 'Cruise No.', key: 'cruise_no' },
  { label: 'Primary Station', key: 'p_sta_no' },
  { label: 'SEAMAP Station', key: 's_sta_no' },
  { label: 'Start Depth (m)', key: 'depth_ssta' },
  { label: 'End Depth (m)', key: 'depth_esta' },
  { label: 'Gear', key: 'gears' },
  { label: 'Stat Zone', key: 'stat_zone' },
  { label: 'Latitude', key: 'decslat' },
  { label: 'Longitude', key: 'decslon' },
]

export const formatPlanktonStationRowForExport = (row) => ({ ...row })

export default function PointDataTablePlankton({ data }) {
  if (!data) return null

  return (
    <Box sx={{ width: '100%', px: { xs: '0.5rem', sm: '1rem' } }}>
      <Box sx={{ mb: { xs: 1, sm: 2 } }}>
        <Typography variant="h6" sx={{ color: '#2E5A88', fontSize: { xs: '0.9rem', sm: '1rem' } }}>
          Plankton Station Details
        </Typography>
      </Box>
      <TableContainer component={Paper} elevation={2} sx={{ width: '100%', overflowX: 'auto' }}>
        <Table sx={{ width: '100%', minWidth: { xs: '900px', md: '100%' } }}>
          <TableHead>
            <TableRow>
              {PLANKTON_STATION_COLUMNS.map((col) => (
                <TableCell
                  key={col.key}
                  sx={{
                    fontWeight: 'bold',
                    backgroundColor: '#f5f5f5',
                    borderBottom: '2px solid #ccc',
                    color: '#1a2a3a',
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                    whiteSpace: 'nowrap'
                  }}
                >
                  {col.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow sx={{ '&:nth-of-type(odd)': { backgroundColor: 'grey.50' } }}>
              {PLANKTON_STATION_COLUMNS.map((col) => (
                <TableCell
                  key={col.key}
                  sx={{
                    color: '#333333',
                    fontSize: { xs: '0.75rem', sm: '0.875rem' },
                    whiteSpace: 'nowrap'
                  }}
                >
                  {data[col.key] ?? ''}
                </TableCell>
              ))}
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}
